<!--<app-navigator [navigator]="navigator"></app-navigator>-->
<div *ngIf="dashboardCounter || dashboardNews; else waiting" class="text-right">

  <span *ngFor="let card of dashboardCounter; let i = index" >
        <span class="badge  dashboardBadge " *ngFor="let count of card.data">
            {{count.title}}
            <span class="badge bg-primary badgeAram">{{count.value}}</span>
            <span class="sr-only">{{card.title | uppercase}}</span>
        </span>
    </span>
</div>
<hr>
<ng-container *ngIf="(dashboardCounter || dashboardNews); else waiting">
    <div class="row">
        <div class="col-12 col-lg-8">
            <div class="inside" #container>
                <div class="row">
                    <div class="col-12 col-md-8 px-1">
                        <h4 *ngIf="userInfo?.role=='U'" class="titleContainer" ><span>{{'dashboard.invoices_user_data' | translate }}</span> {{userInfo!.denominazione}} | {{'users.personal.piva' | translate}}: {{userInfo!.cfpiva}}</h4>
                        <h4 *ngIf="userInfo?.role!='U'" class="titleContainer" ><span>{{'dashboard.your_invoices' | translate }}</span> {{userInfo!.denominazione}} | {{'users.personal.piva' | translate}}: {{userInfo!.cfpiva}}</h4>
                    </div>
                    <div class="col-12 col-md-4 text-right">
                        <a href="javascript:void(0)" (click)="refreshData()"><strong>{{ 'general.update_data' | translate }}</strong></a> | {{'general.updated_at' | translate}} : {{refreshTime | date: 'dd-LL-y HH:mm:ss'}}
                    </div>
                    <div class="col-12 col-md-4 px-1">
                        <div class="card w-100" [ngStyle]="{'background': 'var(--bgColor)'}">
                            <div class="titleCard">
                                <h5 class="roboSubtitle">{{'dashboard.invoice_discarded_15' | translate | uppercase}}</h5>
                                <div class="col-12 col-md-4 text-right">
                                    <a href="javascript:void(0)" (click)="refreshScartate()"><strong>{{ 'general.update' | translate }}</strong></a>
                                </div>
                            </div>
                            <div class="bodyCard" *ngIf="scartateList.length>0" style="max-height: 300px;overflow-y: auto;">
                                <div *ngIf="this.scartate"  class="counter">
                                    <h5 class="roboSubtitle">Conteggio</h5>
                                    <h5 class="roboSubtitle">{{numeroScartate}}</h5>
                                </div>
                                <div *ngFor="let item of scartateList; index as i;" class="row border-bottom" placement="top" [ngbTooltip]="item.error" style="cursor:pointer" (click)="getErrorDescription(i)">
                                    <div class="col-4">{{ 'general.number' | translate }} {{item.invoice_n}}</div>
                                    <div class="col-8 text-right"><small class="text-lowercase">{{ 'general.state' | translate }}</small> {{item.workflow_state}}</div>
                                    <div class="col-12">{{ 'general.recipient' | translate }} {{item.denominazione}}</div>
                                    <div class="col-6">{{ 'general.amount' | translate }} {{formattaAmount(item.amount)}} €</div>
                                    <div class="col-6 text-right">{{ 'general.data' | translate }} {{item.invoice_data |  date: 'dd-LL-y'}}</div>
                                </div>
                            </div>
                            <div class="bodyCard" *ngIf="scartateList.length == 0" style="max-height: 300px;overflow-y: auto;">
                                <div class="counter">
                                    <h5 class="roboSubtitle" *ngIf="scartate">{{'dashboard.no_invoice_discarded' | translate}}</h5>
                                    <h5 class="roboSubtitle" *ngIf="!scartate">{{'dashboard.no_data' | translate}}</h5>
                                    <h5 class="roboSubtitle" *ngIf="updateScartate">{{'dashboard.updating' | translate}}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 px-1">
                        <div class="card w-100" [ngStyle]="{'background': 'var(--bgColor)'}">
                            <div class="titleCard">
                                <h5 class="roboSubtitle">{{'dashboard.draft_invoices' | translate | uppercase}}</h5>
                                <div class="col-12 col-md-4 text-right">
                                    <a href="javascript:void(0)" (click)="refreshBozze()"><strong>{{ 'general.update' | translate }}</strong></a>
                                </div>
                            </div>
                            <div class="bodyCard" *ngIf="bozzeList.length>0" style="max-height: 300px;overflow-y: auto;">
                                <div *ngIf="this.bozze"  class="counter">
                                    <h5 class="roboSubtitle">Conteggio</h5>
                                    <h5 class="roboSubtitle">{{numeroBozze}}</h5>
                                </div>
                                <div *ngFor="let item of bozzeList; index as i;" class="row border-bottom">
                                    <div class="col-4">{{ 'general.number' | translate }} {{item.invoice_n}}</div>
                                    <div class="col-8 text-right"><small class="text-lowercase">{{ 'general.state' | translate }} </small> <span class="font-weight-bold">{{item.workflow_state}}</span></div>
                                    <div class="col-12">{{ 'general.recipient' | translate }} {{item.denominazione}}</div>
                                    <div class="col-6">{{ 'general.amount' | translate }} {{formattaAmount(item.amount)}} €</div>
                                    <div class="col-6 text-right">{{ 'general.data' | translate }} {{item.invoice_data |  date: 'dd-LL-y'}}</div>
                                </div>
                            </div>
                            <div class="bodyCard" *ngIf="bozzeList.length==0" style="max-height: 300px;overflow-y: auto;">
                                <div class="counter">
                                    <h5 class="roboSubtitle" *ngIf="bozze">{{'dashboard.no_drat_invoices' | translate}}</h5>
                                    <h5 class="roboSubtitle" *ngIf="!bozze">{{'dashboard.no_data' | translate}}</h5>
                                    <h5 class="roboSubtitle" *ngIf="updateBozze">{{'dashboard.updating' | translate}}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                        <div class="col-12 col-md-4 px-1">
                            <div class="card w-100" [ngStyle]="{'background': 'var(--bgColor)'}">
                                <div class="titleCard">
                                    <h5 class="roboSubtitle">{{'dashboard.invoices_received' | translate | uppercase}}</h5>
                                    <!--<img [src]="'assets/icone_dashboard/fattura_dashboard.svg'" style="width: 30px;">-->
                                    <div class="col-12 col-md-4 text-right">
                                        <a href="javascript:void(0)" (click)="refreshRicevute()"><strong>{{ 'general.update' | translate }}</strong></a>
                                    </div>
                                </div>
                                <div class="bodyCard" *ngIf="ricevuteList.length>0" style="max-height: 300px;overflow-y: auto;">
                                    <div *ngFor="let item of ricevuteList" class="row border-bottom">
                                        <div class="col-6">{{ 'general.number' | translate }} {{item.invoice_n}}</div>
                                        <div class="col-12">{{ 'general.sender' | translate }}<span class="font-weight-bold"> {{item.denominazione}}</span></div>
                                        <div class="col-6">{{ 'general.amount' | translate }} {{formattaAmount(item.amount)}} €</div>
                                        <div class="col-6 text-right">{{ 'general.data' | translate }} {{item.invoice_data |  date: 'dd-LL-y'}}</div>
                                    </div>
                                </div>
                                <div class="bodyCard" *ngIf="ricevuteList.length==0" style="max-height: 300px;overflow-y: auto;">
                                    <div class="counter">
                                        <h5 class="roboSubtitle" *ngIf="ricevute">{{'dashboard.no_invoice_reiceved' | translate}}</h5>
                                        <h5 class="roboSubtitle" *ngIf="!ricevute">{{'dashboard.no_data' | translate}}</h5>
                                        <h5 class="roboSubtitle" *ngIf="updateRicevute">{{'dashboard.updating' | translate}}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
                <hr>

                <!-- DASHBOARD RIVENDITORE -->
                <div class="row" *ngIf="userInfo!.role == 'R'">
                    <div style="padding: 20px 15px 0 5px">
                        <h4 class="titleContainer" >{{'dashboard.your_clients_invoices' | translate}}</h4>
                    </div>
                    <div class="col-12 col-md-4 px-1">
                        <div class="card w-100" [ngStyle]="{'background': 'var(--bgColor)'}">
                            <div class="titleCard">
                                <h5 class="roboSubtitle">{{'dashboard.clients_invoice_discarded' | translate | uppercase}}</h5>
                               <!-- <img [src]="'assets/icone_dashboard/fattura_dashboard.svg'" style="width: 30px;">-->
                                <div class="col-12 col-md-4 text-right">
                                    <a href="javascript:void(0)" (click)="refreshScartateClienti()"><strong>{{ 'general.update' | translate }}</strong></a>
                                </div>
                            </div>
                            <div class="bodyCard" *ngIf="elencoClientiScartate.length>0" style="max-height: 300px;overflow-y: auto;">
                                <div *ngFor="let utente of elencoClientiScartate" class="counter" style="cursor: zoom-in" [routerLink]="['../invoices']" (click) = 'setSessionUser(utente.u)'>
                                    <h5  class="roboSubtitle">{{utente.username}}</h5>    
                                    <h5  class="roboSubtitle">{{utente.scartate}}</h5>    
                                </div>
                            </div>
                            <div class="bodyCard" *ngIf="elencoClientiScartate.length==0" style="max-height: 300px;overflow-y: auto;">
                                <div class="counter">
                                    <h5 class="roboSubtitle" >{{'dashboard.no_invoice_discarded' | translate}}</h5>
                                </div>
                            </div>
                        </div>

                        <div class="card w-100" [ngStyle]="{'background': 'var(--bgColor)'}">
                            <div class="titleCard">
                                <h5 class="roboSubtitle">{{'dashboard.clients_invoice_draft' | translate | uppercase}}</h5>
                                <div class="col-12 col-md-4 text-right">
                                    <a href="javascript:void(0)" (click)="refreshBozzeClienti()"><strong>{{ 'general.update' | translate }}</strong></a>
                                </div>
                               <!-- <img [src]="'assets/icone_dashboard/fattura_dashboard.svg'" style="width: 30px;">-->
                            </div>
                            <div class="bodyCard" *ngIf="elencoClientiBozze.length>0" style="max-height: 300px;overflow-y: auto;">
                                <div *ngFor="let utente of elencoClientiBozze" class="counter" style="cursor: zoom-in" [routerLink]="['../invoices']" (click) = 'setSessionUser(utente.u)'>
                                    <h5  class="roboSubtitle">{{utente.username}}</h5>    
                                    <h5  class="roboSubtitle">{{utente.bozze}}</h5>    
                                </div>
                            </div>
                            <div class="bodyCard" *ngIf="elencoClientiBozze.length==0" style="max-height: 300px;overflow-y: auto;">
                                <div class="counter">
                                    <h5 class="roboSubtitle">{{'dashboard.no_invoice_draft' | translate}}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                
            </div>
            <app-grafici *ngIf="userInfo!.email=='info@ar4mdigital.it'"></app-grafici>

        </div>
        

        <!--<div class="col-12 col-lg-4 " *ngIf="dashboardNews">
            <ng-container *ngIf="dashboardNews.length > 0">
                <ng-container *ngIf="dashboardNews[0] != null">
                    <ng-container *ngFor="let newsList of dashboardNews">
                            <div  style="padding: 20px 15px 0 15px">
                                <h4 class="titleContainer">{{newsList.title}}</h4>
                                <div class="listNews" *ngFor="let news of newsList.data">
                                    <div class="col-12" [innerHTML]="sanitizer.bypassSecurityTrustHtml(news.title)"></div>
                                    <hr>
                                </div>
                            </div>
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>-->
    </div>    
</ng-container>
<ng-template #waiting>
    <app-loading></app-loading>
</ng-template>